import { useTranslation } from 'react-i18next';

type RatioFormatMode = 'ratio' | 'percent' | 'percentAndRatio';

export default function useRatioFormat(mode?: RatioFormatMode) {
  const { i18n } = useTranslation();
  const percentFormat = new Intl.NumberFormat(i18n.language, { style: 'percent', maximumFractionDigits: 1 });
  const numberFormat = new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 1 });

  function format(item: { numerator: number, denominator: number }) {
    if (item.denominator <= 0) return '-';
    const result = `${numberFormat.format(item.numerator)}/${numberFormat.format(item.denominator)}`;
    if (mode === 'percentAndRatio') return `(${percentFormat.format(item.numerator / item.denominator)}) ${result}`;
    if (mode === 'percent') return `${percentFormat.format(item.numerator / item.denominator)}`;
    return result;
  }
  return { format };
}
